const newsItemMixin = {
	computed: {
		path: function() {
			console.log(this.item.sysCode)
			const item = this.item;
			// const linkArr = this.item.news_link.split('|');
			// const linkType = linkArr[0];
			// if(linkType === '3') {
			// 	return linkArr[1];
			// }
			// else {
				if(item.type === 'subject') {
					return '#/topic/' + item.articleId;
				}
				else if(item.type === 'image') {
					return '#/img/'+item.sysCode+'/'+item.categoryId+'/'+item.articleId;
				}
				else if(item.type==='link'){
					return item.link;
				}
				else {
					if(item.sysCode=="article"){
						return '#/detail/normal/'+item.articleId;
					}else if(item.sysCode=="paper"){
						return '#/detail/paper/'+item.articleId;
					}
				}
			//}
		}
	}
};

export default newsItemMixin






// WEBPACK FOOTER //
// ./src/mixins/news-item.js